let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9FhBz")).then(() => parcelRequire('gHjiO'));